






























































import { Component, Mixins, PropSync, Prop } from 'vue-property-decorator';
import APP_CONST from '@/constants/AppConst';
import { ScreenText } from '@/lang/ScreenText';
import AccountSettings from '@/mixins/accountSettings.mixin';
import { PaymentPlans } from '@/Model/checkout/cart/types';
import BaseModal from '@/popupcomponents/BaseModal.vue';
import APP_UTILITIES from '@/utilities/commonFunctions';

@Component({
  components: {
    BaseModal
  }
})
export default class CheckoutPaymentScheduleModal extends Mixins(AccountSettings) {
  @PropSync('isVisible') isVisibleSync!: boolean;
  @Prop() selectedPaymentPlan!: PaymentPlans;
  private screenText = new ScreenText();
  public sessionPriceDecimalPrecision = APP_CONST.SESSION_PRICE_DECIMAL_PRECISION;

  get paymentPlan(): PaymentPlans {
    return this.selectedPaymentPlan || {
      title: '',
      subtitle: '',
      dueNow: {
        amount: 0,
        frequency: 1
      },
      futurePayments: {
        amount: 0,
        frequency: 1
      }
    };
  }

  mounted() {
    if (this.isVisibleSync === undefined) {
      this.isVisibleSync = false;
    }
  }

  formatAmount(amount: number): string {
    return `$${amount.toFixed(this.sessionPriceDecimalPrecision)}`;
  }

  formatDate(date: string): string {
    return APP_UTILITIES.formatLongDateFromDateTime(date);
  }

  closeModal() {
    this.isVisibleSync = false;
  }
}
